import React, { createContext, useContext } from "react";

const MyScopeContext = createContext(false);

/** Marks everything under the /my shell, where every record is the viewer's own. */
export const MyScopeProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <MyScopeContext.Provider value>{children}</MyScopeContext.Provider>;

export const useIsMyScope = (): boolean => useContext(MyScopeContext);
